import { Stack , useMediaQuery } from '@mui/material';
import { GridColDef, GridRowClassNameParams } from '@mui/x-data-grid-pro';
import React from 'react';

import { PartChildrenListProps } from './PartChildrenList.props';
import { StyledTableWrapper, StyledTypography } from './PartChildrenList.styles';
import { ActionPermissions } from '../../../@types';
import { ScreenSize } from '../../../@types/display.types';
import { GridDensityTypes } from '../../../configs/enums';
import { calculateDateTimeDuration, formatDate } from '../../../utils/common';
import { Accordian } from '../../atoms/Accordian';
import { DataGrid } from '../../atoms/DataGrid';
import { PermissionLink } from '../../atoms/PermissionLink';
import { Typography, TypographyVariantProps } from '../../atoms/Typography';



export const PartChildrenList: React.FC<PartChildrenListProps> = ({
  partChildrenListData
}) => {
  const isMobileView = useMediaQuery(ScreenSize.MOBILE);

  const columns: GridColDef[] = [
    {
      field: 'serial1',
      headerName: 'Serials 1',
      flex: 1,
      renderCell: (params) => (<PermissionLink permission={ActionPermissions.Part_Search} href={`/parts/${params.row.id}`}>{params.row.serial1}</PermissionLink>)
    },
    {
      field: 'serial2',
      headerName: 'Serials 2',
      flex: 1
    },
    {
      field: 'serial3',
      headerName: 'Serials 3',
      flex: 1
    },
    {
      field: 'partTypeName',
      headerName: 'Part Type Name',
      minWidth: 200,
      flex: 1
    },
    {
      field: 'partTypeNumber',
      headerName: 'Part Type Number',
      minWidth: 200,
      flex: 1
    },
    {
      field: 'updatedAt',
      headerName: 'Datestamp',
      minWidth: 200,
      flex: 1,
      renderCell: (params) => (
        <Stack>
          <Typography variant={TypographyVariantProps.Body2}>{formatDate(params.row.updatedAt)}</Typography>
          <StyledTypography variant={TypographyVariantProps.Body2}>{calculateDateTimeDuration(params.row.updatedAt)}</StyledTypography>
        </Stack>
      )
    },
  ];

  return (
    <Accordian title="Child Parts" defaultExpanded={true}>
      <StyledTableWrapper>
        <DataGrid
          density={GridDensityTypes.Standard}
          columns={columns}
          rows={partChildrenListData}
          getRowId={(row) => row?.id}
          disableColumnFilter={true}
          disableColumnSelector={true}
          disableDensitySelector={true}
          componentsProps={{
            toolbar: {
              csvOptions: { disableToolbarButton: true },
              printOptions: { disableToolbarButton: true },
              showQuickFilter: false
            }
          }}
          getRowClassName={(params: GridRowClassNameParams) => `super-app-theme--${params.row.logTypeCode}`}
          autoHeight={true}
          getRowHeight={() => 'auto'}
          initialState={{
            columns: {
              columnVisibilityModel: {
                serial2: !isMobileView,
                serial3: !isMobileView,
                partTypeNumber: !isMobileView,
                updatedAt: !isMobileView
              }
            }
          }}
        />
      </StyledTableWrapper>
    </Accordian>
  );
};